/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import { _ as _objectWithoutProperties } from '../_chunks/dep-92728dc5.js';
import React, { forwardRef, useState, useRef, useEffect, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Popup } from '../popup/index.js';
import useConfig from '../hooks/useConfig.js';
import { tooltipDefaultProps } from './defaultProps.js';
import '../_chunks/dep-2acfafca.js';
import '../popup/Popup.js';
import 'react-transition-group';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import 'react-popper';
import '../hooks/useControlled.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-c1f93350.js';
import '../_chunks/dep-7dce2c26.js';
import '../_util/noop.js';
import '../_util/useAnimation.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../hooks/usePrevious.js';
import '../common/Portal.js';
import 'react-dom';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_util/easing.js';
import '../popup/hooks/useTrigger.js';
import 'react-is';
import '../popup/utils/ref.js';
import '../_util/composeRefs.js';
import '../popup/utils/transition.js';
import '../_util/useMutationObserver.js';
import '../_chunks/dep-01ce608f.js';
import '../_chunks/dep-77a54538.js';
import '../_util/useWindowSize.js';
import '../popup/defaultProps.js';
import '../popup/style/css.js';
import '../popup/type.js';

var _excluded = ["theme", "showArrow", "destroyOnClose", "overlayClassName", "children", "duration", "placement", "onVisibleChange"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Tooltip = /*#__PURE__*/forwardRef(function (props, ref) {
  var theme = props.theme,
    showArrow = props.showArrow,
    destroyOnClose = props.destroyOnClose,
    overlayClassName = props.overlayClassName,
    children = props.children,
    duration = props.duration,
    placement = props.placement,
    onVisibleChange = props.onVisibleChange,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    timeUp = _useState2[0],
    setTimeUp = _useState2[1];
  var popupRef = useRef(null);
  var timerRef = useRef(null);
  var toolTipClass = classNames("".concat(classPrefix, "-tooltip"), _defineProperty({}, "".concat(classPrefix, "-tooltip--").concat(theme), theme), overlayClassName);
  function handleVisibleChange(visible, _ref) {
    var e = _ref.e,
      trigger = _ref.trigger;
    setTimeUp(false);
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(visible, {
      e: e,
      trigger: trigger
    });
  }
  useEffect(function () {
    if (duration !== 0 && !timeUp) {
      var _popupRef$current, _popupRef$current$set;
      (_popupRef$current = popupRef.current) === null || _popupRef$current === void 0 ? void 0 : (_popupRef$current$set = _popupRef$current.setVisible) === null || _popupRef$current$set === void 0 ? void 0 : _popupRef$current$set.call(_popupRef$current, true);
      timerRef.current = window.setTimeout(function () {
        var _popupRef$current2, _popupRef$current2$se;
        (_popupRef$current2 = popupRef.current) === null || _popupRef$current2 === void 0 ? void 0 : (_popupRef$current2$se = _popupRef$current2.setVisible) === null || _popupRef$current2$se === void 0 ? void 0 : _popupRef$current2$se.call(_popupRef$current2, false);
        setTimeUp(true);
      }, duration);
    }
    return function () {
      window.clearTimeout(timerRef.current);
    };
  }, [duration, timeUp]);
  useImperativeHandle(ref, function () {
    return _objectSpread({}, popupRef.current || {});
  });
  return /* @__PURE__ */React.createElement(Popup, _objectSpread({
    ref: popupRef,
    destroyOnClose: destroyOnClose,
    showArrow: showArrow,
    overlayClassName: toolTipClass,
    onVisibleChange: handleVisibleChange,
    placement: placement
  }, restProps), children);
});
Tooltip.displayName = "Tooltip";
Tooltip.defaultProps = tooltipDefaultProps;

export { Tooltip as default };
//# sourceMappingURL=Tooltip.js.map
